import { useMatch } from 'react-router-dom';
import { useIsComparisonActive } from '@/hooks/useIsComparisonActive';

export const useComparisonFilterTabsActive = () => {
  const isComparisonActive = useIsComparisonActive();
  const isRadarPage = !!useMatch('/:locale/:entity/:entityId/radar/*');

  return isComparisonActive && isRadarPage;
};
